import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _52e0aa89 = () => interopDefault(import('../pages/30-jahre-telekom.vue' /* webpackChunkName: "pages/30-jahre-telekom" */))
const _b3471bbc = () => interopDefault(import('../pages/30-jahre-telekom-endgeraete.vue' /* webpackChunkName: "pages/30-jahre-telekom-endgeraete" */))
const _7c24bc88 = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _771ad1fb = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _00850172 = () => interopDefault(import('../pages/bitte-kommen-sie-spaeter-wieder.vue' /* webpackChunkName: "pages/bitte-kommen-sie-spaeter-wieder" */))
const _2d88cf1f = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _a95321e8 = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _8d430aec = () => interopDefault(import('../pages/handyvergleich.vue' /* webpackChunkName: "pages/handyvergleich" */))
const _5373c0ea = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _4c37a9cd = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _0bdf4c80 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _3ab3b6c3 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _dfed1802 = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _659ab86a = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _a96ca710 = () => interopDefault(import('../pages/ratenzahlung.vue' /* webpackChunkName: "pages/ratenzahlung" */))
const _a9b0909a = () => interopDefault(import('../pages/redirecting.vue' /* webpackChunkName: "pages/redirecting" */))
const _dce24a2c = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _5130faaa = () => interopDefault(import('../pages/samsung-cashback-aktion.vue' /* webpackChunkName: "pages/samsung-cashback-aktion" */))
const _b9448814 = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _5c58c8ca = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _50177468 = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _4d9a8cb2 = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _28349746 = () => interopDefault(import('../pages/urlaubsessentials.vue' /* webpackChunkName: "pages/urlaubsessentials" */))
const _732b19c4 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _07920f1f = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _17adc231 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _6d1a74d6 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _2ff50336 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _ccdcd7b8 = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _5e456b10 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _6866a3aa = () => interopDefault(import('../pages/magenta-black-days/page-data.js' /* webpackChunkName: "pages/magenta-black-days/page-data" */))
const _38345ce5 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _65b25a8a = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _50fcee7b = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _13166254 = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _80724f0a = () => interopDefault(import('../pages/shop/kundenformular.vue' /* webpackChunkName: "pages/shop/kundenformular" */))
const _13afd6be = () => interopDefault(import('../pages/shop/kundenformular/index.vue' /* webpackChunkName: "pages/shop/kundenformular/index" */))
const _e89c31d0 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _455ff89f = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _320e7e10 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _14b2583b = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _d1c68416 = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _03a9d6af = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _61fc6eba = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _ebd4052a = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _54bfbf25 = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _c5362e4c = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _c27d88fc = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _1978c124 = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _ddd2a882 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _445f6648 = () => interopDefault(import('../pages/magenta-moments-2024/_slug.vue' /* webpackChunkName: "pages/magenta-moments-2024/_slug" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/30-jahre-telekom",
    component: _52e0aa89,
    name: "30-jahre-telekom"
  }, {
    path: "/30-jahre-telekom-endgeraete",
    component: _b3471bbc,
    name: "30-jahre-telekom-endgeraete"
  }, {
    path: "/a-good-company",
    component: _7c24bc88,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _771ad1fb,
    name: "anker"
  }, {
    path: "/bitte-kommen-sie-spaeter-wieder",
    component: _00850172,
    name: "bitte-kommen-sie-spaeter-wieder"
  }, {
    path: "/google",
    component: _2d88cf1f,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _a95321e8,
    name: "handyrechnung-aktion"
  }, {
    path: "/handyvergleich",
    component: _8d430aec,
    name: "handyvergleich"
  }, {
    path: "/infos-zum-online-kauf",
    component: _5373c0ea,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _4c37a9cd,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _0bdf4c80,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _3ab3b6c3,
    name: "merkliste"
  }, {
    path: "/panzerglass",
    component: _dfed1802,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _659ab86a,
    name: "preisvorteile-sichern"
  }, {
    path: "/ratenzahlung",
    component: _a96ca710,
    name: "ratenzahlung"
  }, {
    path: "/redirecting",
    component: _a9b0909a,
    name: "redirecting"
  }, {
    path: "/samsung",
    component: _dce24a2c,
    name: "samsung"
  }, {
    path: "/samsung-cashback-aktion",
    component: _5130faaa,
    name: "samsung-cashback-aktion"
  }, {
    path: "/smart-home-entdecken",
    component: _b9448814,
    name: "smart-home-entdecken"
  }, {
    path: "/soundcore",
    component: _5c58c8ca,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _50177468,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _4d9a8cb2,
    name: "themenwelten"
  }, {
    path: "/urlaubsessentials",
    component: _28349746,
    name: "urlaubsessentials"
  }, {
    path: "/xiaomi",
    component: _732b19c4,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _07920f1f,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _17adc231,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _6d1a74d6,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _2ff50336,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _ccdcd7b8,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _5e456b10,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/magenta-black-days/page-data",
    component: _6866a3aa,
    name: "magenta-black-days-page-data"
  }, {
    path: "/samsung/product-data",
    component: _38345ce5,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _65b25a8a,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _50fcee7b,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _13166254,
    name: "shop-fehler"
  }, {
    path: "/shop/kundenformular",
    component: _80724f0a,
    children: [{
      path: "",
      component: _13afd6be,
      name: "shop-kundenformular"
    }, {
      path: "persoenliche-daten",
      component: _e89c31d0,
      name: "shop-kundenformular-persoenliche-daten"
    }, {
      path: "zahlungsart",
      component: _455ff89f,
      name: "shop-kundenformular-zahlungsart"
    }]
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _320e7e10,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _14b2583b,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _d1c68416,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _03a9d6af,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _61fc6eba,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _ebd4052a,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _54bfbf25,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _c5362e4c,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _c27d88fc,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _1978c124,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/",
    component: _ddd2a882,
    name: "index"
  }, {
    path: "/magenta-moments-2024/:slug?",
    component: _445f6648,
    name: "magenta-moments-2024-slug"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
